import { Record } from 'immutable';
import { parseTrue } from './parseBool';

export default Record({
  bigBank: parseTrue(process.env.BIG_BANK_FEATURES),
  dialogue: parseTrue(process.env.DIALOGUE_FEATURES)
});


// WEBPACK FOOTER //
// ./src/utils/EnvFeatures.js